export const BaseDropdownInjectionKey = 'base-dropdown'
